import * as React from 'react';
type Props = {
  className?: string;
};
export function List({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-list"
      className={className}
    >
      <path
        d="M5.00161 4.06V19.94C4.99309 20.1287 5.03816 20.3159 5.13161 20.48C5.22396 20.6403 5.35897 20.7718 5.52161 20.86C5.68527 20.9538 5.87361 20.9957 6.06161 20.98C6.24311 20.9469 6.41847 20.8862 6.58161 20.8L8.43161 19.42C8.60097 19.2994 8.80371 19.2346 9.01161 19.2346C9.21952 19.2346 9.42225 19.2994 9.59161 19.42L11.4516 20.66C11.6149 20.7675 11.8061 20.8248 12.0016 20.8248C12.1971 20.8248 12.3883 20.7675 12.5516 20.66L14.4116 19.42C14.581 19.2994 14.7837 19.2346 14.9916 19.2346C15.1995 19.2346 15.4023 19.2994 15.5716 19.42L17.4216 20.8C17.5848 20.8862 17.7601 20.9469 17.9416 20.98C18.1296 20.9957 18.318 20.9538 18.4816 20.86C18.6443 20.7718 18.7793 20.6403 18.8716 20.48C18.9651 20.3159 19.0101 20.1287 19.0016 19.94V4.06C19.0166 3.79641 18.9267 3.53759 18.7516 3.34C18.5785 3.14156 18.3342 3.01939 18.0716 3H5.93161C5.66902 3.01939 5.42468 3.14156 5.25161 3.34C5.0765 3.53759 4.98663 3.79641 5.00161 4.06Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00162 14.17C9.00162 14.17 9.00162 14.59 10.0016 14.59C11.0016 14.59 11.0016 14.17 12.0016 14.17C13.0016 14.17 13.0016 14.59 14.0016 14.59C15.0016 14.59 15.0016 14.17 16.0016 14.17"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M8.00162 10.79C9.00162 10.79 9.00162 11.19 10.0016 11.19C11.0016 11.19 11.0016 10.79 12.0016 10.79C13.0016 10.79 13.0016 11.19 14.0016 11.19C15.0016 11.19 15.0016 10.79 16.0016 10.79"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M8.00162 7.41C9.00162 7.41 9.00162 7.81 10.0016 7.81C11.0016 7.81 11.0016 7.41 12.0016 7.41C13.0016 7.41 13.0016 7.81 14.0016 7.81C15.0016 7.81 15.0016 7.41 16.0016 7.41"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
